<template>
    <div>
        <el-form-item prop="contents" label="批量更新内容:" :rules="[{ type: 'array', required: true, message: '请选择更新内容' }]">
            <el-checkbox-group v-model="formData.contents">
                <el-checkbox :label="1">启动图名称</el-checkbox>
                <el-checkbox :label="2">展示时间</el-checkbox>
                <el-checkbox :label="3">展示权重</el-checkbox>
                <el-checkbox :label="4">启动图</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="ids" label="需同步更新的其他启动图:"
            :rules="[{ type: 'array', required: dataList && dataList.length > 0 ? true : false, message: '请选择需批量更新的启动图' }]">
            <span slot="label">需同步更新的其他启动图：<small><span class="el-icon-warning"></span> 以下仅包括其他同名且未隐藏的启动图</small></span>
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                @selection-change="handleSelectionChange" empty-text="不存在与当前启动图同名称的其他其他启动图" :max-height="400">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="名称"></el-table-column>
            </el-table>
        </el-form-item>

        <div v-if="dataList.length > 0" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getTourList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        formData: {
            type: Object,
            default: null
        },
        queryValue: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            dataList: [],
            listLoading: false,
            params: {
                pageNo: 1,
                pageSize: 50,
                showType: 2,
                type: 2,
                value: ''
            },
            totalCount: '',
        }
    },
    created(){
        this.params.value = this.queryValue;
        this.getTourList();
    },

    methods: {
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getTourList();
        },
        handleSelectionChange(v) {
            this.formData.ids = v.map(v => v.id);
        },
        getTourList() {
            this.listLoading = true;
            this.$request({
                url: "/diagram/pageList",
                method: "POST",
                data: { ...this.params },
            })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.dataList = result.result || [];

                        this.totalCount = result.totalCount;
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        }
    }
}
</script>